import { render, staticRenderFns } from "./RPTabList.vue?vue&type=template&id=80c1aef0&scoped=true&style=margin-bottom%3A%200px%3B%20height%3A%2040px%3B"
import script from "./RPTabList.vue?vue&type=script&lang=js"
export * from "./RPTabList.vue?vue&type=script&lang=js"
import style0 from "./RPTabList.vue?vue&type=style&index=0&id=80c1aef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c1aef0",
  null
  
)

export default component.exports